<template lang="html">
  <div id="app">
    <TopBar></TopBar>
    <NavMenu ref="NavMenu" @on-select="turnToPage"></NavMenu>
    <div class="tag-nav-container">
      <div class="tag-nav-wrapper">
        <TagsNav :value="$route" @input="handleClick" :list="tagNavList" @on-close="handleCloseTag"/>
      </div>
    </div>
    <div class="action-bar">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"/>
        </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"/>
      <!-- <keep-alive :include="cacheList">
        <router-view></router-view>
      </keep-alive> -->
    </div>
  </div>
</template>
<script>
import { routeEqual, getRouteByPath, getNewTagList, getNextRoute } from '@/lib/util'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import routers from '@/router/routers'
import TopBar from '@/components/layout/TopBar'
import NavMenu from '@/components/layout/NavMenu'
import TagsNav from './tags-nav'

export default {
  name: 'app',
  data () {
    return {
      transitionName: ''
    }
  },
  computed: {
    tagNavList () {
      return this.$store.state.app.tagNavList
    },
    cacheList () {
      return ['ParentView', ...this.tagNavList.length ? this.tagNavList.filter(item => !(item.meta && !item.meta.keepAlive)).map(item => item.name) : []]
    },
  },
  components: {
    TopBar,
    NavMenu,
    TagsNav
  },
  watch: {
    '$route' (newRoute) {
      //路由切换效果
      this.transitionName = 'slide-right'
      const { name, query, params, meta, path } = newRoute
      this.addTag({
        route: { name, query, params, meta, path },
        type: 'push'
      })
      this.setBreadCrumb(newRoute)
      this.setTagNavList(getNewTagList(this.tagNavList, newRoute))
    }
  },
  mounted () {
    /**
     * @description 初始化设置面包屑导航和标签导航
     */
    this.setTagNavList()
    this.setHomeRoute(routers)
    this.addTag({
      route: this.$store.state.app.homeRoute
    })
    this.setBreadCrumb(this.$route)
    // 如果当前打开页面不在标签栏中，跳到homeName页
    if (!this.tagNavList.find(item => item.name === this.$route.name)) {
      this.$router.push({
        name: this.$config.homeName
      })
    }
  },
  methods: {
    ...mapMutations([
      'setBreadCrumb',
      'setTagNavList',
      'addTag',
      'setHomeRoute'
    ]),
    turnToPage (route) {
      let { name, params, query } = {}
      if (typeof route === 'string') {
        route = getRouteByPath(routers, route)
        name = route.name
      }
      else {
        name = route.name
        params = route.params
        query = route.query
      }
      this.$router.push({
        name,
        params,
        query
      })
    },
    handleClick (item) {
      this.turnToPage(item)
    },
    handleCloseTag (res, type, route) {
      if (type === 'all') {
        this.turnToPage('/index/index')
      } else if (routeEqual(this.$route, route)) {
        if (type !== 'others') {
          const nextRoute = getNextRoute(this.tagNavList, route)
          this.$router.push(nextRoute)
        }
      }
      this.setTagNavList(res)
    },
  }
}
</script>

<style lang="scss" scope>
  .tag-nav-container {
    position: fixed;
    top: 75px;
    left: 250px;
    right: 0;
    height: 40px;
    z-index: 99;
    background: white;
    .tag-nav-wrapper{
      padding: 0;
      height: 40px;
      background: #F0F0F0;
    }
  }
  .action-bar {
    position: fixed;
    padding: 20px 25px;
    top: 125px;
    left: 250px;
    right: 0;
    bottom: 0;
    z-index: 99;
    overflow-y: auto;
    background: white;
  }
  /*路由切换动画*/
  .slide-right-enter-active,
  .slide-right-leave-active,
  .slide-left-enter-active,
  .slide-left-leave-active {
    will-change: transform;
    transition: all 500ms;
    position: absolute;
  }
  .slide-right-enter {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
  .slide-right-leave-active {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
  .slide-left-enter {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
  .slide-left-leave-active {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
</style>




// WEBPACK FOOTER //
// src/components/layout/index.vue